import React, { useState } from 'react';
import styled from 'styled-components/native';
import Colors from '../constants/Colors';
import { B } from './Typography';

const StyledStudiesBarView = styled.View<{
  trackColor?: string;
  type?: 'studies' | 'default' | 'rewards';
}>`
  width: 100%;
  height: ${p => (p.type === 'rewards' ? 30 : 8)}px;
  overflow: hidden;
  align-content: flex-end;
  background-color: ${p => p.trackColor || '#FFF'};
  border-radius: ${p => (p.type === 'rewards' ? 15 : 0)}px;
`;

const StyledStudiesProgressBar = styled.View<{
  color?: string;
  width: number;
  type?: 'studies' | 'default' | 'rewards';
}>`
  align-self: flex-start;
  width: ${p => p.width}%;
  height: ${p => (p.type === 'rewards' ? 30 : 20)}px;
  border-radius: ${p => (p.type === 'rewards' ? 15 : 0)}px;
  justify-content: center;
  align-items: flex-end;
  background-color: ${p => (p.color ? p.color : '#5B4FC2')};
`;

const StyledB = styled(B)<{ labelColor?: string }>`
  font-family: 'WorkSans-SemiBold';
  font-size: 11px;
  align-self: flex-end;
  line-height: 13.13px;
  color: ${p => (p.labelColor ? p.labelColor : 'black')};
`;

const StyledLabelView = styled.View<{ leftAlign?: boolean }>`
  height: 100%;
  align-items: center;
  position: absolute;
  justify-content: center;
  align-self: ${p => (p.leftAlign ? 'flex-start' : 'flex-end')};
  padding-right: 8px;
`;

export interface ProgressBarProps {
  progress: number;
  type?: 'studies' | 'default' | 'rewards';
  total?: number;
  completed?: number;
  progressColor?: string;
  labelColor?: string;
  trackColor?: string;
}

const ProgressBar: React.FC<ProgressBarProps> = ({
  progress,
  type,
  total,
  completed,
  progressColor,
  labelColor,
  trackColor
}) => {
  const [showProgressValue, setShowProgressValue] = useState(true);
  const activity = 100 * progress;
  const track = !activity ? 100 : 100 * (1 - progress);

  return (
    <StyledStudiesBarView trackColor={trackColor} type={type}>
      {/*<StyledLabelView>*/}
      {/*  <StyledB>{total}</StyledB>*/}
      {/*</StyledLabelView>*/}
      {activity !== 0 && (
        <StyledStudiesProgressBar
          type={type}
          width={activity}
          color={progressColor}
          onLayout={event => {
            const { width } = event.nativeEvent.layout;
            if (width > 16) {
              setShowProgressValue(true);
            } else {
              setShowProgressValue(false);
            }
          }}
        >
          {showProgressValue && (
            <StyledLabelView>
              <StyledB labelColor={labelColor}>{completed}</StyledB>
            </StyledLabelView>
          )}
        </StyledStudiesProgressBar>
      )}
      {completed == 0 && (
        <StyledLabelView leftAlign={true}>
          <StyledB labelColor={Colors.secondary}>0</StyledB>
        </StyledLabelView>
      )}
    </StyledStudiesBarView>
  );
};

export default ProgressBar;
